module.exports = __webpack_public_path__ + "img/烟感.8566419a.jpg";